import {Preferences} from "@capacitor/preferences";

const isTravelAllowanceEnabled = async () => {
    const isTravelAllowanceEnabled = await Preferences.get({'key': 'travel_allowance_enabled'});

    return isTravelAllowanceEnabled.value === '1';
}

const getFieldNameWithPrefix = (fieldName: string, prefix: string | undefined) => {
    return prefix ? `${prefix}.${fieldName}` : fieldName;
};

export {
    isTravelAllowanceEnabled,
    getFieldNameWithPrefix,
};